import CryptoJS from "crypto-js";
import Cookies from "js-cookie";
import dateFormat, { masks } from "dateformat";
import { updateSsoHandshakeToNo } from "./client_api_calls";
import { clearClientSession, clearAgentSession, removeCookie, getParentDomain } from "./cookieUtils";

class HelperClass {
  constructor() {}
  isLogin() {
    if (
      Cookies.get("acn__") == null ||
      Cookies.get("acn__") === undefined ||
      Cookies.get("acn__") === "" ||
      Cookies.get("tkn__") === undefined ||
      Cookies.get("tkn__") === null ||
      Cookies.get("tkn__") === ""
    ) {
      return false;
    } else {
      try {
        var bytes = CryptoJS.AES.decrypt(
          Cookies.get("tkn__"),
          process.env.REACT_APP_SIGNATURE
        );
        var tkn__ = bytes.toString(CryptoJS.enc.Utf8);
        if (!tkn__) {
          console.info("[AUTH] isLogin: tkn__ decryption yielded empty");
          window.location.replace("/login");
          return false;
        }

        var secByte = CryptoJS.AES.decrypt(
          Cookies.get("acn__"),
          process.env.REACT_APP_SIGNATURE
        );
        var acn__ = secByte.toString(CryptoJS.enc.Utf8);
        if (!acn__) {
          console.info("[AUTH] isLogin: acn__ decryption yielded empty");
          window.location.replace("/login");
          return false;
        }

        if (tkn__ === "" || acn__ === "") {
          window.location.replace("/login");
          return false;
        } else {
          return true;
        }
      } catch (e) {
        console.error("[AUTH] isLogin: cookie decryption error", e.message);
        window.location.replace("/login");
        return false;
      }
    }
  }

  isAdminLogin() {
    if (
      Cookies.get("admin_acc__") == null ||
      Cookies.get("admin_acc__") === undefined ||
      Cookies.get("admin_acc__") === "" ||
      Cookies.get("admin_token__") === undefined ||
      Cookies.get("admin_token__") === null ||
      Cookies.get("admin_token__") === ""
    ) {
      return false;
    } else {
      try {
        var bytes = CryptoJS.AES.decrypt(
          Cookies.get("admin_token__"),
          process.env.REACT_APP_SIGNATURE
        );
        var admin_token__ = bytes.toString(CryptoJS.enc.Utf8);
        if (!admin_token__) {
          window.location.replace("/nsaccess");
          return false;
        }

        var secByte = CryptoJS.AES.decrypt(
          Cookies.get("admin_acc__"),
          process.env.REACT_APP_SIGNATURE
        );
        var admin_acc__ = secByte.toString(CryptoJS.enc.Utf8);
        if (!admin_acc__) {
          window.location.replace("/nsaccess");
          return false;
        }

        if (admin_token__ === "" || admin_acc__ === "") {
          window.location.replace("/nsaccess");
          return false;
        } else {
          return true;
        }
      } catch (e) {
        console.error("[AUTH] isAdminLogin: cookie decryption error", e.message);
        window.location.replace("/nsaccess");
        return false;
      }
    }
  }

  getCompName() {
    if (
      Cookies.get("comp_nme__") == null ||
      Cookies.get("comp_nme__") === undefined ||
      Cookies.get("comp_nme__") === ""
    ) {
      return false;
    } else {
      var secByte = CryptoJS.AES.decrypt(
        Cookies.get("comp_nme__"),
        process.env.REACT_APP_SIGNATURE
      );
      if (secByte == "") {
        return false;
      }
      var comp_nme__ = secByte.toString(CryptoJS.enc.Utf8);

      if (comp_nme__ == "") {
        return false;
      } else {
        return comp_nme__;
      }
    }
  }

  getName() {
    if (
      Cookies.get("name__") == null ||
      Cookies.get("name__") === undefined ||
      Cookies.get("name__") === ""
    ) {
      return false;
    } else {
      var secByte = CryptoJS.AES.decrypt(
        Cookies.get("name__"),
        process.env.REACT_APP_SIGNATURE
      );
      if (secByte == "") {
        return false;
      }
      var name__ = secByte.toString(CryptoJS.enc.Utf8);

      if (name__ == "") {
        return false;
      } else {
        return name__;
      }
    }
  }

  getEmail() {
    if (
      Cookies.get("eml__") == null ||
      Cookies.get("eml__") === undefined ||
      Cookies.get("eml__") === ""
    ) {
      return false;
    } else {
      var secByte = CryptoJS.AES.decrypt(
        Cookies.get("eml__"),
        process.env.REACT_APP_SIGNATURE
      );
      if (secByte == "") {
        return false;
      }
      var eml__ = secByte.toString(CryptoJS.enc.Utf8);

      if (eml__ == "") {
        return false;
      } else {
        return eml__;
      }
    }
  }

  getTitle() {
    if (
      Cookies.get("title__") == null ||
      Cookies.get("title__") === undefined ||
      Cookies.get("title__") === ""
    ) {
      return false;
    } else {
      var secByte = CryptoJS.AES.decrypt(
        Cookies.get("title__"),
        process.env.REACT_APP_SIGNATURE
      );
      if (secByte == "") {
        return false;
      }
      var title__ = secByte.toString(CryptoJS.enc.Utf8);

      if (title__ == "") {
        return false;
      } else {
        return title__;
      }
    }
  }

  getAddress() {
    if (
      Cookies.get("adress__") == null ||
      Cookies.get("adress__") === undefined ||
      Cookies.get("adress__") === ""
    ) {
      return false;
    } else {
      var secByte = CryptoJS.AES.decrypt(
        Cookies.get("adress__"),
        process.env.REACT_APP_SIGNATURE
      );
      if (secByte == "") {
        return false;
      }
      var adress__ = secByte.toString(CryptoJS.enc.Utf8);

      if (adress__ == "") {
        return false;
      } else {
        return adress__;
      }
    }
  }

  getCity() {
    if (
      Cookies.get("city__") == null ||
      Cookies.get("city__") === undefined ||
      Cookies.get("city__") === ""
    ) {
      return false;
    } else {
      var secByte = CryptoJS.AES.decrypt(
        Cookies.get("city__"),
        process.env.REACT_APP_SIGNATURE
      );
      if (secByte == "") {
        return false;
      }
      var city__ = secByte.toString(CryptoJS.enc.Utf8);

      if (city__ == "") {
        return false;
      } else {
        return city__;
      }
    }
  }

  getCountry() {
    if (
      Cookies.get("country__") == null ||
      Cookies.get("country__") === undefined ||
      Cookies.get("country__") === ""
    ) {
      return false;
    } else {
      var secByte = CryptoJS.AES.decrypt(
        Cookies.get("country__"),
        process.env.REACT_APP_SIGNATURE
      );
      if (secByte == "") {
        return false;
      }
      var country__ = secByte.toString(CryptoJS.enc.Utf8);

      if (country__ == "") {
        return false;
      } else {
        return country__;
      }
    }
  }

  getState() {
    if (
      Cookies.get("state__") == null ||
      Cookies.get("state__") === undefined ||
      Cookies.get("state__") === ""
    ) {
      return false;
    } else {
      var secByte = CryptoJS.AES.decrypt(
        Cookies.get("state__"),
        process.env.REACT_APP_SIGNATURE
      );
      if (secByte == "") {
        return false;
      }
      var state__ = secByte.toString(CryptoJS.enc.Utf8);

      if (state__ == "") {
        return false;
      } else {
        return state__;
      }
    }
  }

  getParentAcctAgent() {
    if (
      Cookies.get("agent_parent_accountno__") == null ||
      Cookies.get("agent_parent_accountno__") === undefined ||
      Cookies.get("agent_parent_accountno__") === ""
    ) {
      return false;
    } else {
      var secByte = CryptoJS.AES.decrypt(
        Cookies.get("agent_parent_accountno__"),
        process.env.REACT_APP_SIGNATURE
      );
      if (secByte == "") {
        return false;
      }
      var agent_parent_accountno__ = secByte.toString(CryptoJS.enc.Utf8);

      if (agent_parent_accountno__ == "") {
        return false;
      } else {
        return agent_parent_accountno__;
      }
    }
  }

  // Partner Sub-Agent marker: returns the owning MAIN Agent's accountno when
  // the logged-in agent is a Sub-Agent, false for true Main Agents (used to
  // hide the Sub Users / Sub Agents header entries).
  getMainAgentAcct() {
    if (
      Cookies.get("agent_main_accountno__") == null ||
      Cookies.get("agent_main_accountno__") === undefined ||
      Cookies.get("agent_main_accountno__") === ""
    ) {
      return false;
    } else {
      var secByte = CryptoJS.AES.decrypt(
        Cookies.get("agent_main_accountno__"),
        process.env.REACT_APP_SIGNATURE
      );
      if (secByte == "") {
        return false;
      }
      var agent_main_accountno__ = secByte.toString(CryptoJS.enc.Utf8);

      if (agent_main_accountno__ == "") {
        return false;
      } else {
        return agent_main_accountno__;
      }
    }
  }

  getUserTypeAgent() {
    if (
      Cookies.get("agent_type__") == null ||
      Cookies.get("agent_type__") === undefined ||
      Cookies.get("agent_type__") === ""
    ) {
      return false;
    } else {
      var secByte = CryptoJS.AES.decrypt(
        Cookies.get("agent_type__"),
        process.env.REACT_APP_SIGNATURE
      );
      if (secByte == "") {
        return false;
      }
      var agent_type__ = secByte.toString(CryptoJS.enc.Utf8);

      if (agent_type__ == "") {
        return false;
      } else {
        return agent_type__;
      }
    }
  }

  getZip() {
    if (
      Cookies.get("zip__") == null ||
      Cookies.get("zip__") === undefined ||
      Cookies.get("zip__") === ""
    ) {
      return false;
    } else {
      var secByte = CryptoJS.AES.decrypt(
        Cookies.get("zip__"),
        process.env.REACT_APP_SIGNATURE
      );
      if (secByte == "") {
        return false;
      }
      var zip__ = secByte.toString(CryptoJS.enc.Utf8);

      if (zip__ == "") {
        return false;
      } else {
        return zip__;
      }
    }
  }

  getSharelinkLimit() {
    if (
      Cookies.get("sharelink_limit__") == null ||
      Cookies.get("sharelink_limit__") === undefined ||
      Cookies.get("sharelink_limit__") === ""
    ) {
      return false;
    } else {
      var secByte = CryptoJS.AES.decrypt(
        Cookies.get("sharelink_limit__"),
        process.env.REACT_APP_SIGNATURE
      );
      if (secByte == "") {
        return false;
      }
      var sharelink_limit__ = secByte.toString(CryptoJS.enc.Utf8);

      if (sharelink_limit__ == "") {
        return false;
      } else {
        return sharelink_limit__;
      }
    }
  }

  getPhone() {
    if (
      Cookies.get("phone__") == null ||
      Cookies.get("phone__") === undefined ||
      Cookies.get("phone__") === ""
    ) {
      return false;
    } else {
      var secByte = CryptoJS.AES.decrypt(
        Cookies.get("phone__"),
        process.env.REACT_APP_SIGNATURE
      );
      if (secByte == "") {
        return false;
      }
      var phone__ = secByte.toString(CryptoJS.enc.Utf8);

      if (phone__ == "") {
        return false;
      } else {
        return phone__;
      }
    }
  }

  getAccount() {
    if (
      Cookies.get("acn__") == null ||
      Cookies.get("acn__") === undefined ||
      Cookies.get("acn__") === ""
    ) {
      return false;
    } else {
      var secByte = CryptoJS.AES.decrypt(
        Cookies.get("acn__"),
        process.env.REACT_APP_SIGNATURE
      );
      if (secByte == "") {
        return false;
      }
      var acn__ = secByte.toString(CryptoJS.enc.Utf8);

      if (acn__ == "") {
        return false;
      } else {
        return acn__;
      }
    }
  }

  getToken() {
    if (
      Cookies.get("tkn__") == null ||
      Cookies.get("tkn__") === undefined ||
      Cookies.get("tkn__") === ""
    ) {
      return false;
    } else {
      var secByte = CryptoJS.AES.decrypt(
        Cookies.get("tkn__"),
        process.env.REACT_APP_SIGNATURE
      );
      if (secByte == "") {
        return false;
      }
      var tkn__ = secByte.toString(CryptoJS.enc.Utf8);

      if (tkn__ == "") {
        return false;
      } else {
        return tkn__;
      }
    }
  }

  getAdminType() {
    if (
      Cookies.get("admin_type__") == null ||
      Cookies.get("admin_type__") === undefined ||
      Cookies.get("admin_type__") === ""
    ) {
      return false;
    } else {
      var secByte = CryptoJS.AES.decrypt(
        Cookies.get("admin_type__"),
        process.env.REACT_APP_SIGNATURE
      );
      if (secByte == "") {
        return false;
      }
      var admin_type__ = secByte.toString(CryptoJS.enc.Utf8);

      if (admin_type__ == "") {
        return false;
      } else {
        return admin_type__;
      }
    }
  }

  getAdminName() {
    if (
      Cookies.get("admin_name__") == null ||
      Cookies.get("admin_name__") === undefined ||
      Cookies.get("admin_name__") === ""
    ) {
      return false;
    } else {
      var secByte = CryptoJS.AES.decrypt(
        Cookies.get("admin_name__"),
        process.env.REACT_APP_SIGNATURE
      );
      if (secByte == "") {
        return false;
      }
      var admin_name__ = secByte.toString(CryptoJS.enc.Utf8);

      if (admin_name__ == "") {
        return false;
      } else {
        return admin_name__;
      }
    }
  }

  getAdminFullName() {
    if (
      Cookies.get("full_name__") == null ||
      Cookies.get("full_name__") === undefined ||
      Cookies.get("full_name__") === ""
    ) {
      return false;
    } else {
      var secByte = CryptoJS.AES.decrypt(
        Cookies.get("full_name__"),
        process.env.REACT_APP_SIGNATURE
      );
      if (secByte == "") {
        return false;
      }
      var full_name__ = secByte.toString(CryptoJS.enc.Utf8);

      if (full_name__ == "") {
        return false;
      } else {
        return full_name__;
      }
    }
  }

  getAdminEmail() {
    if (
      Cookies.get("admin_eml__") == null ||
      Cookies.get("admin_eml__") === undefined ||
      Cookies.get("admin_eml__") === ""
    ) {
      return false;
    } else {
      var secByte = CryptoJS.AES.decrypt(
        Cookies.get("admin_eml__"),
        process.env.REACT_APP_SIGNATURE
      );
      if (secByte == "") {
        return false;
      }
      var admin_eml__ = secByte.toString(CryptoJS.enc.Utf8);

      if (admin_eml__ == "") {
        return false;
      } else {
        return admin_eml__;
      }
    }
  }

  getAdminAccount() {
    if (
      Cookies.get("admin_acc__") == null ||
      Cookies.get("admin_acc__") === undefined ||
      Cookies.get("admin_acc__") === ""
    ) {
      return false;
    } else {
      var secByte = CryptoJS.AES.decrypt(
        Cookies.get("admin_acc__"),
        process.env.REACT_APP_SIGNATURE
      );
      if (secByte == "") {
        return false;
      }
      var admin_acc__ = secByte.toString(CryptoJS.enc.Utf8);

      if (admin_acc__ == "") {
        return false;
      } else {
        return admin_acc__;
      }
    }
  }

  getAdminToken() {
    if (
      Cookies.get("admin_token__") == null ||
      Cookies.get("admin_token__") === undefined ||
      Cookies.get("admin_token__") === ""
    ) {
      return false;
    } else {
      var secByte = CryptoJS.AES.decrypt(
        Cookies.get("admin_token__"),
        process.env.REACT_APP_SIGNATURE
      );
      if (secByte == "") {
        return false;
      }
      var admin_token__ = secByte.toString(CryptoJS.enc.Utf8);

      if (admin_token__ == "") {
        return false;
      } else {
        return admin_token__;
      }
    }
  }

  getResellerIdentifier() {
    if (
      Cookies.get("resellerhash__") == null ||
      Cookies.get("resellerhash__") === undefined ||
      Cookies.get("resellerhash__") === ""
    ) {
      return false;
    } else {
      var secByte = CryptoJS.AES.decrypt(
        Cookies.get("resellerhash__"),
        process.env.REACT_APP_SIGNATURE
      );
      if (secByte == "") {
        return false;
      }
      var resellerhash__ = secByte.toString(CryptoJS.enc.Utf8);

      if (resellerhash__ == "") {
        return false;
      } else {
        return resellerhash__;
      }
    }
  }

  getResellerReturnUrl() {
    if (
      Cookies.get("resellerreturnurl__") == null ||
      Cookies.get("resellerreturnurl__") === undefined ||
      Cookies.get("resellerreturnurl__") === ""
    ) {
      return false;
    } else {
      var secByte = CryptoJS.AES.decrypt(
        Cookies.get("resellerreturnurl__"),
        process.env.REACT_APP_SIGNATURE
      );
      if (secByte == "") {
        return false;
      }
      var resellerreturnurl__ = secByte.toString(CryptoJS.enc.Utf8);

      if (resellerreturnurl__ == "") {
        return false;
      } else {
        return resellerreturnurl__;
      }
    }
  }

  getResellerPrivacyUrl() {
    if (
      Cookies.get("resellerprivacyurl__") == null ||
      Cookies.get("resellerprivacyurl__") === undefined ||
      Cookies.get("resellerprivacyurl__") === ""
    ) {
      return false;
    } else {
      var secByte = CryptoJS.AES.decrypt(
        Cookies.get("resellerprivacyurl__"),
        process.env.REACT_APP_SIGNATURE
      );
      if (secByte == "") {
        return false;
      }
      var resellerprivacyurl__ = secByte.toString(CryptoJS.enc.Utf8);

      if (resellerprivacyurl__ == "") {
        return false;
      } else {
        return resellerprivacyurl__;
      }
    }
  }
  getResellerTermsUrl() {
    //Agent or Sub Agent
    if (
      Cookies.get("resellertermsurl__") == null ||
      Cookies.get("resellertermsurl__") === undefined ||
      Cookies.get("resellertermsurl__") === ""
    ) {
      return false;
    } else {
      var secByte = CryptoJS.AES.decrypt(
        Cookies.get("resellertermsurl__"),
        process.env.REACT_APP_SIGNATURE
      );
      if (secByte == "") {
        return false;
      }
      var resellertermsurl__ = secByte.toString(CryptoJS.enc.Utf8);

      if (resellertermsurl__ == "") {
        return false;
      } else {
        return resellertermsurl__;
      }
    }
  }

  getResellerRegTitle() {
    //Agent or Sub Agent
    if (
      Cookies.get("resellercompanyname__") == null ||
      Cookies.get("resellercompanyname__") === undefined ||
      Cookies.get("resellercompanyname__") === ""
    ) {
      return false;
    } else {
      var secByte = CryptoJS.AES.decrypt(
        Cookies.get("resellercompanyname__"),
        process.env.REACT_APP_SIGNATURE
      );
      if (secByte == "") {
        return false;
      }
      var resellercompanyname__ = secByte.toString(CryptoJS.enc.Utf8);

      if (resellercompanyname__ == "") {
        return false;
      } else {
        return resellercompanyname__;
      }
    }
  }

  getResellerLogo() {
    //Agent or Sub Agent
    if (
      Cookies.get("reslogo__") == null ||
      Cookies.get("reslogo__") === undefined ||
      Cookies.get("reslogo__") === ""
    ) {
      return false;
    } else {
      var secByte = CryptoJS.AES.decrypt(
        Cookies.get("reslogo__"),
        process.env.REACT_APP_SIGNATURE
      );
      if (secByte == "") {
        return false;
      }
      var reslogo__ = secByte.toString(CryptoJS.enc.Utf8);

      if (reslogo__ == "") {
        return false;
      } else {
        return reslogo__;
      }
    }
  }

  getResellerSignature() {
    //Agent or Sub Agent
    if (
      Cookies.get("ressig__") == null ||
      Cookies.get("ressig__") === undefined ||
      Cookies.get("ressig__") === ""
    ) {
      return false;
    } else {
      var secByte = CryptoJS.AES.decrypt(
        Cookies.get("ressig__"),
        process.env.REACT_APP_SIGNATURE
      );
      if (secByte == "") {
        return false;
      }
      var ressig__ = secByte.toString(CryptoJS.enc.Utf8);

      if (ressig__ == "") {
        return false;
      } else {
        return ressig__;
      }
    }
  }

  getSuperAgentTitle() {
    //Agent or Sub Agent
    if (
      Cookies.get("agttitle__") == null ||
      Cookies.get("agttitle__") === undefined ||
      Cookies.get("agttitle__") === ""
    ) {
      return false;
    } else {
      var secByte = CryptoJS.AES.decrypt(
        Cookies.get("agttitle__"),
        process.env.REACT_APP_SIGNATURE
      );
      if (secByte == "") {
        return false;
      }
      var agttitle__ = secByte.toString(CryptoJS.enc.Utf8);

      if (agttitle__ == "") {
        return false;
      } else {
        return agttitle__;
      }
    }
  }

  getSuperAgentAcct() {
    //Agent or Sub Agent
    if (
      Cookies.get("agtacctno__") == null ||
      Cookies.get("agtacctno__") === undefined ||
      Cookies.get("agtacctno__") === ""
    ) {
      return false;
    } else {
      var secByte = CryptoJS.AES.decrypt(
        Cookies.get("agtacctno__"),
        process.env.REACT_APP_SIGNATURE
      );
      if (secByte == "") {
        return false;
      }
      var agtacctno__ = secByte.toString(CryptoJS.enc.Utf8);

      if (agtacctno__ == "") {
        return false;
      } else {
        return agtacctno__;
      }
    }
  }

  getUrlType() {
    //Agent or Sub Agent
    if (
      Cookies.get("urltype__") == null ||
      Cookies.get("urltype__") === undefined ||
      Cookies.get("urltype__") === ""
    ) {
      return false;
    } else {
      var secByte = CryptoJS.AES.decrypt(
        Cookies.get("urltype__"),
        process.env.REACT_APP_SIGNATURE
      );
      if (secByte == "") {
        return false;
      }
      var urltype__ = secByte.toString(CryptoJS.enc.Utf8);

      if (urltype__ == "") {
        return false;
      } else {
        return urltype__;
      }
    }
  }

  logout() {
    // Clear per-account agreement signing prefs (saved signature + "I confirm"
    // identity consent) before cookies are wiped so a fresh login always
    // re-confirms and re-signs.
    this.clearAgreementSigningPrefs(this.getAccount());
    // Read redirect target BEFORE clearing cookies
    let residentifier = "";
    try {
      var resByte = CryptoJS.AES.decrypt(
        Cookies.get("residentifier__"),
        process.env.REACT_APP_SIGNATURE
      );
      residentifier = resByte.toString(CryptoJS.enc.Utf8);
    } catch (e) {
      console.error("[AUTH] logout: failed to decrypt residentifier", e.message);
    }
    clearAgentSession();
    return window.location.replace(residentifier + "/agent");
  }

  adminlogout() {
    Cookies.remove("admin_name__");
    Cookies.remove("admin_type__");
    Cookies.remove("admin_eml__");
    Cookies.remove("admin_acc__");
    Cookies.remove("admin_token__");
    return window.location.replace("/nsaccess");
  }

  //CLIENT PORTAL HELPERS
  isClientLogin() {
    if (
      Cookies.get("client_acn__") == null ||
      Cookies.get("client_acn__") === undefined ||
      Cookies.get("client_acn__") === "" ||
      Cookies.get("client_tkn__") === undefined ||
      Cookies.get("client_tkn__") === null ||
      Cookies.get("client_tkn__") === ""
    ) {
      console.info("[AUTH] isClientLogin: client cookies missing");
      return false;
    } else {
      try {
        var bytes = CryptoJS.AES.decrypt(
          Cookies.get("client_tkn__"),
          process.env.REACT_APP_SIGNATURE
        );
        var client_tkn__ = bytes.toString(CryptoJS.enc.Utf8);
        if (!client_tkn__) {
          console.info("[AUTH] isClientLogin: client_tkn__ decryption yielded empty");
          window.location.replace("/client");
          return false;
        }

        var secByte = CryptoJS.AES.decrypt(
          Cookies.get("client_acn__"),
          process.env.REACT_APP_SIGNATURE
        );
        var client_acn__ = secByte.toString(CryptoJS.enc.Utf8);
        if (!client_acn__) {
          console.info("[AUTH] isClientLogin: client_acn__ decryption yielded empty");
          window.location.replace("/client");
          return false;
        }

        if (client_tkn__ === "" || client_acn__ === "") {
          window.location.replace("/client");
          return false;
        } else {
          return true;
        }
      } catch (e) {
        console.error("[AUTH] isClientLogin: cookie decryption error", e.message);
        window.location.replace("/client");
        return false;
      }
    }
  }

  getNameClient() {
    if (
      Cookies.get("client_name__") == null ||
      Cookies.get("client_name__") === undefined ||
      Cookies.get("client_name__") === ""
    ) {
      return false;
    } else {
      var secByte = CryptoJS.AES.decrypt(
        Cookies.get("client_name__"),
        process.env.REACT_APP_SIGNATURE
      );
      if (secByte == "") {
        return false;
      }
      var client_name__ = secByte.toString(CryptoJS.enc.Utf8);

      if (client_name__ == "") {
        return false;
      } else {
        return client_name__;
      }
    }
  }

  getCountryClient() {
    if (
      Cookies.get("client_country__") == null ||
      Cookies.get("client_country__") === undefined ||
      Cookies.get("client_country__") === ""
    ) {
      return false;
    } else {
      var secByte = CryptoJS.AES.decrypt(
        Cookies.get("client_country__"),
        process.env.REACT_APP_SIGNATURE
      );
      if (secByte == "") {
        return false;
      }
      var client_country__ = secByte.toString(CryptoJS.enc.Utf8);

      if (client_country__ == "") {
        return false;
      } else {
        return client_country__;
      }
    }
  }

  getCompNameClient() {
    if (
      Cookies.get("client_comp_nme__") == null ||
      Cookies.get("client_comp_nme__") === undefined ||
      Cookies.get("client_comp_nme__") === ""
    ) {
      return false;
    } else {
      var secByte = CryptoJS.AES.decrypt(
        Cookies.get("client_comp_nme__"),
        process.env.REACT_APP_SIGNATURE
      );
      if (secByte == "") {
        return false;
      }
      var client_comp_nme__ = secByte.toString(CryptoJS.enc.Utf8);

      if (client_comp_nme__ == "") {
        return false;
      } else {
        return client_comp_nme__;
      }
    }
  }

  getFilerID() {
    if (
      Cookies.get("filer_id__") == null ||
      Cookies.get("filer_id__") === undefined ||
      Cookies.get("filer_id__") === ""
    ) {
      return false;
    } else {
      var secByte = CryptoJS.AES.decrypt(
        Cookies.get("filer_id__"),
        process.env.REACT_APP_SIGNATURE
      );
      if (secByte == "") {
        return false;
      }
      var filer_id__ = secByte.toString(CryptoJS.enc.Utf8);

      if (filer_id__ == "") {
        return false;
      } else {
        return filer_id__;
      }
    }
  }

  getUserTypeClient() {
    if (
      Cookies.get("client_user_type__") == null ||
      Cookies.get("client_user_type__") === undefined ||
      Cookies.get("client_user_type__") === ""
    ) {
      return false;
    } else {
      var secByte = CryptoJS.AES.decrypt(
        Cookies.get("client_user_type__"),
        process.env.REACT_APP_SIGNATURE
      );
      if (secByte == "") {
        return false;
      }
      var client_user_type__ = secByte.toString(CryptoJS.enc.Utf8);

      if (client_user_type__ == "") {
        return false;
      } else {
        return client_user_type__;
      }
    }
  }

  getParentAcctClient() {
    if (
      Cookies.get("client_parent_accountno__") == null ||
      Cookies.get("client_parent_accountno__") === undefined ||
      Cookies.get("client_parent_accountno__") === ""
    ) {
      return false;
    } else {
      var secByte = CryptoJS.AES.decrypt(
        Cookies.get("client_parent_accountno__"),
        process.env.REACT_APP_SIGNATURE
      );
      if (secByte == "") {
        return false;
      }
      var client_parent_accountno__ = secByte.toString(CryptoJS.enc.Utf8);

      if (client_parent_accountno__ == "") {
        return false;
      } else {
        return client_parent_accountno__;
      }
    }
  }

  getEmailClient() {
    if (
      Cookies.get("client_eml__") == null ||
      Cookies.get("client_eml__") === undefined ||
      Cookies.get("client_eml__") === ""
    ) {
      return false;
    } else {
      var secByte = CryptoJS.AES.decrypt(
        Cookies.get("client_eml__"),
        process.env.REACT_APP_SIGNATURE
      );
      if (secByte == "") {
        return false;
      }
      var client_eml__ = secByte.toString(CryptoJS.enc.Utf8);

      if (client_eml__ == "") {
        return false;
      } else {
        return client_eml__;
      }
    }
  }

  getClientAccount() {
    if (
      Cookies.get("client_acn__") == null ||
      Cookies.get("client_acn__") === undefined ||
      Cookies.get("client_acn__") === ""
    ) {
      return false;
    } else {
      var secByte = CryptoJS.AES.decrypt(
        Cookies.get("client_acn__"),
        process.env.REACT_APP_SIGNATURE
      );
      if (secByte == "") {
        return false;
      }
      var client_acn__ = secByte.toString(CryptoJS.enc.Utf8);

      if (client_acn__ == "") {
        return false;
      } else {
        return client_acn__;
      }
    }
  }

  getClientToken() {
    if (
      Cookies.get("client_tkn__") == null ||
      Cookies.get("client_tkn__") === undefined ||
      Cookies.get("client_tkn__") === ""
    ) {
      return false;
    } else {
      var secByte = CryptoJS.AES.decrypt(
        Cookies.get("client_tkn__"),
        process.env.REACT_APP_SIGNATURE
      );
      if (secByte == "") {
        return false;
      }
      var client_tkn__ = secByte.toString(CryptoJS.enc.Utf8);

      if (client_tkn__ == "") {
        return false;
      } else {
        return client_tkn__;
      }
    }
  }
  getPhoneClient() {
    if (
      Cookies.get("client_phone__") == null ||
      Cookies.get("client_phone__") === undefined ||
      Cookies.get("client_phone__") === ""
    ) {
      return false;
    } else {
      var secByte = CryptoJS.AES.decrypt(
        Cookies.get("client_phone__"),
        process.env.REACT_APP_SIGNATURE
      );
      if (secByte == "") {
        return false;
      }
      var client_phone__ = secByte.toString(CryptoJS.enc.Utf8);

      if (client_phone__ == "") {
        return false;
      } else {
        return client_phone__;
      }
    }
  }
  getTitleClient() {
    if (
      Cookies.get("client_title__") == null ||
      Cookies.get("client_title__") === undefined ||
      Cookies.get("client_title__") === ""
    ) {
      return false;
    } else {
      var secByte = CryptoJS.AES.decrypt(
        Cookies.get("client_title__"),
        process.env.REACT_APP_SIGNATURE
      );
      if (secByte == "") {
        return false;
      }
      var client_title__ = secByte.toString(CryptoJS.enc.Utf8);

      if (client_title__ == "") {
        return false;
      } else {
        return client_title__;
      }
    }
  }

  getDomainNameClient() {
    if (
      Cookies.get("client_domain_name__") == null ||
      Cookies.get("client_domain_name__") === undefined ||
      Cookies.get("client_domain_name__") === ""
    ) {
      return false;
    } else {
      var secByte = CryptoJS.AES.decrypt(
        Cookies.get("client_domain_name__"),
        process.env.REACT_APP_SIGNATURE
      );
      if (secByte == "") {
        return false;
      }
      var client_domain_name__ = secByte.toString(CryptoJS.enc.Utf8);

      if (client_domain_name__ == "") {
        return false;
      } else {
        return client_domain_name__;
      }
    }
  }

  getClientService() {
    if (
      Cookies.get("clientserviceid__") == null ||
      Cookies.get("clientserviceid__") === undefined ||
      Cookies.get("clientserviceid__") === ""
    ) {
      return false;
    } else {
      var secByte = CryptoJS.AES.decrypt(
        Cookies.get("clientserviceid__"),
        process.env.REACT_APP_SIGNATURE
      );
      if (secByte == "") {
        return false;
      }
      var clientserviceid__ = secByte.toString(CryptoJS.enc.Utf8);

      if (clientserviceid__ == "") {
        return false;
      } else {
        return clientserviceid__;
      }
    }
  }

  getClientServiceType() {
    if (
      Cookies.get("clientservicetype__") == null ||
      Cookies.get("clientservicetype__") === undefined ||
      Cookies.get("clientservicetype__") === ""
    ) {
      return false;
    } else {
      var secByte = CryptoJS.AES.decrypt(
        Cookies.get("clientservicetype__"),
        process.env.REACT_APP_SIGNATURE
      );
      if (secByte == "") {
        return false;
      }
      var clientservicetype__ = secByte.toString(CryptoJS.enc.Utf8);

      if (clientservicetype__ == "") {
        return false;
      } else {
        return clientservicetype__;
      }
    }
  }

  getClientAddress() {
    if (
      Cookies.get("client_adress__") == null ||
      Cookies.get("client_adress__") === undefined ||
      Cookies.get("client_adress__") === ""
    ) {
      return false;
    } else {
      var secByte = CryptoJS.AES.decrypt(
        Cookies.get("client_adress__"),
        process.env.REACT_APP_SIGNATURE
      );
      if (secByte == "") {
        return false;
      }
      var client_adress__ = secByte.toString(CryptoJS.enc.Utf8);

      if (client_adress__ == "") {
        return false;
      } else {
        return client_adress__;
      }
    }
  }

  getVAReturnUrl() {
    if (
      Cookies.get("client_return_url__") == null ||
      Cookies.get("client_return_url__") === undefined ||
      Cookies.get("client_return_url__") === ""
    ) {
      return false;
    } else {
      var secByte = CryptoJS.AES.decrypt(
        Cookies.get("client_return_url__"),
        process.env.REACT_APP_SIGNATURE
      );
      if (secByte == "") {
        return false;
      }
      var client_return_url__ = secByte.toString(CryptoJS.enc.Utf8);

      if (client_return_url__ == "") {
        return false;
      } else {
        return client_return_url__;
      }
    }
  }

  getResellerRegToken() {
    if (
      Cookies.get("residentifier__") == null ||
      Cookies.get("residentifier__") === undefined ||
      Cookies.get("residentifier__") === ""
    ) {
      return false;
    } else {
      var secByte = CryptoJS.AES.decrypt(
        Cookies.get("residentifier__"),
        process.env.REACT_APP_SIGNATURE
      );
      if (secByte == "") {
        return false;
      }
      var residentifier__ = secByte.toString(CryptoJS.enc.Utf8);

      if (residentifier__ == "") {
        return false;
      } else {
        return residentifier__;
      }
    }
  }

  updateSsoHandshakeToNo = async (email) => {
    const servicesResponce = await updateSsoHandshakeToNo(
      this.getClientAccount(),
      this.getClientToken(),
      email
    );
  };

  // Remove the per-account agreement signing prefs (saved signature +
  // "I confirm" identity consent) so a fresh login always re-confirms and
  // re-signs.
  clearAgreementSigningPrefs(clientAccountNo) {
    if (!clientAccountNo) return;
    try {
      localStorage.removeItem(`lastTypedSignature_${clientAccountNo}`);
      localStorage.removeItem(`lastSignatureClass_${clientAccountNo}`);
      localStorage.removeItem(`lastSignatureType_${clientAccountNo}`);
      localStorage.removeItem(`lastSignatureData_${clientAccountNo}`);
      sessionStorage.removeItem(`authConsentConfirmed_${clientAccountNo}`);
    } catch (e) {
      // ignore storage errors
    }
  }

  async clientLogout(saveRedirectUrl = false) {
    if (saveRedirectUrl) {
      sessionStorage.setItem('redirectAfterLogin', window.location.pathname);
    }
    // Clear per-account signing prefs before cookies are wiped
    this.clearAgreementSigningPrefs(this.getClientAccount());
    // Read redirect target BEFORE clearing cookies
    let residentifier = "";
    try {
      var resByte = CryptoJS.AES.decrypt(
        Cookies.get("residentifier__"),
        process.env.REACT_APP_SIGNATURE
      );
      residentifier = resByte.toString(CryptoJS.enc.Utf8);
    } catch (e) {
      console.error("[AUTH] clientLogout: failed to decrypt residentifier", e.message);
    }

    const handshake = localStorage.getItem("client_sso_handshake") || "No";
    if (handshake === "Yes") {
      try {
        const email = CryptoJS.AES.decrypt(
          Cookies.get("client_eml__"),
          process.env.REACT_APP_SIGNATURE
        ).toString(CryptoJS.enc.Utf8);

        clearClientSession();

        await this.updateSsoHandshakeToNo(email);
        return window.location.replace(
          "https://dev-carrier.voicealerts.com/account/obs_logout"
        );
      } catch (err) {
        console.error("Failed to update SSO handshake to No:", err.message);
      }
    }

    clearClientSession();
    return window.location.replace("/" + residentifier);
  }

  clientLogoutAction(saveRedirectUrl = false) {
    if (saveRedirectUrl) {
      sessionStorage.setItem('redirectAfterLogin', window.location.pathname);
    }
    // Clear per-account signing prefs before cookies are wiped
    this.clearAgreementSigningPrefs(this.getClientAccount());
    // Read redirect target BEFORE clearing cookies
    let residentifier = "";
    try {
      var resByte = CryptoJS.AES.decrypt(
        Cookies.get("residentifier__"),
        process.env.REACT_APP_SIGNATURE
      );
      residentifier = resByte.toString(CryptoJS.enc.Utf8);
    } catch (e) {
      console.error("[AUTH] clientLogoutAction: failed to decrypt residentifier", e.message);
    }

    clearClientSession();
    return window.location.replace("/" + residentifier);
  }

  formatUsPhoneNumber(number) {
    const cleaned = ("" + number).replace(/\D/g, "");
    const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      return `(${match[1]}) ${match[2]}-${match[3]}`;
    }
    return number;
  }

  formatDateTime(date) {
    if (date && date !== "") {
      return dateFormat(date, "mm-dd-yyyy, h:MM:ss TT");
    }
    return "---";
  }
  formatDate(date) {
    if (date && date !== "") {
      return dateFormat(date, "mm-dd-yyyy");
    }
    return "---";
  }
}

export default HelperClass;
